import { MenuItem } from '@headlessui/react';
import clsx from 'clsx';
import type React from 'react';
import { Link } from 'react-router';
import { SidebarProfileMenuRow } from './SidebarProfileMenuRow';

interface SidebarProfileLinkRowProps {
  to: string;
  icon: string;
  label: string;
  // Show a chevron_right affordance (navigational rows)
  showChevron?: boolean;
  // Add a bottom divider (every row except the last)
  bordered?: boolean;
  // Destructive action styling (red tint background + text)
  danger?: boolean;
}

export const SidebarProfileLinkRow: React.FC<SidebarProfileLinkRowProps> = ({
  to,
  icon,
  label,
  showChevron,
  bordered,
  danger,
}) => {
  return (
    <MenuItem>
      {({ focus }) => (
        <Link
          to={to}
          className={clsx(
            'block cursor-pointer',
            bordered && 'border-b border-gray-100',
            danger
              ? 'bg-red-50/70 hover:bg-red-100/70'
              : focus && 'bg-primary-hover',
          )}>
          <SidebarProfileMenuRow
            icon={icon}
            label={label}
            trailingIcon={showChevron ? 'chevron_right' : undefined}
            danger={danger}
          />
        </Link>
      )}
    </MenuItem>
  );
};

export default SidebarProfileLinkRow;
